import { defineStore } from 'pinia';
import axios from 'axios';

export const useWorkFirmStore = defineStore('workFirm', {
  state: () => ({
    selectedFirma: null,   // { id, denumire, cui, sigla, tip_entitate, tip_contabilitate, anaf_data_final, user_name, user_email }
    pendingTargetRoute: null, // Submodule path or route object waiting for a firm selection
    isModalOpen: false,    // Controls visibility of ModalSelecteazaFirmaLucru
    loadingFirma: false,
  }),

  getters: {
    hasFirma: (state) => !!(state.selectedFirma && state.selectedFirma.id),
    firmaId: (state) => state.selectedFirma?.id ? Number(state.selectedFirma.id) : null,
    firmaDenumire: (state) => state.selectedFirma?.denumire || '',
    firmaCui: (state) => state.selectedFirma?.cui || '',
    isPfa: (state) => {
      const f = state.selectedFirma;
      if (!f) return false;
      if (f.tip_contabilitate === 'SIMPLIFICATA') return true;
      if (f.tip_entitate === 'PFA' || f.tip_entitate === 'CI' || f.tip_entitate === 'II') return true;
      const den = (f.denumire || '').toUpperCase();
      return den.includes('ÎNTREPRINDERE INDIVIDUALĂ') || den.includes('INTREPRINDERE INDIVIDUALA') || den.includes(' I.I.') || den.includes(' PFA') || den.includes(' I.F.') || den.includes('CABINET') || den.includes(' C.I.') || den.includes(' C.M.I.') || den.includes(' C.I.P.');
    },
  },

  actions: {
    normalizeFirma(raw) {
      if (!raw || typeof raw !== 'object') return null;
      const id = raw.id || raw.firma_id || raw.ID || null;
      const denumire = raw.denumire || raw.denumire_firma || raw.nume || raw.name || '';
      const tipEntitate = raw.tip_entitate || null;
      let tipContabilitate = raw.tip_contabilitate || null;

      if (!tipContabilitate) {
        const dUpper = denumire.toUpperCase();
        if (tipEntitate === 'PFA' || dUpper.includes('ÎNTREPRINDERE INDIVIDUALĂ') || dUpper.includes('INTREPRINDERE INDIVIDUALA') || dUpper.includes(' I.I.') || dUpper.includes(' PFA') || dUpper.includes(' I.F.')) {
          tipContabilitate = 'SIMPLIFICATA';
        }
      }

      return {
        id: Number(id),
        denumire,
        cui: raw.cui || raw.cui_firma || raw.cif || raw.vat || '',
        user_name: raw.user_name || raw.user || raw.utilizator || '',
        user_email: raw.user_email || '',
        sigla: raw.sigla || raw.logo || raw.sigla_url || null,
        tip_entitate: tipEntitate,
        tip_contabilitate: tipContabilitate,
        anaf_data_final: raw.anaf_data_final || null,
      };
    },

    setFirma(firma) {
      if (!firma) {
        this.clearFirma();
        return;
      }
      const normalized = this.normalizeFirma(firma);
      this.selectedFirma = normalized;
      try {
        if (typeof localStorage !== 'undefined' && normalized?.id) {
          localStorage.setItem('active_work_firma', JSON.stringify(normalized));
        }
      } catch (e) {
        console.warn('Eroare la salvarea firmei de lucru in localStorage:', e);
      }
    },

    clearFirma() {
      this.selectedFirma = null;
      try {
        if (typeof localStorage !== 'undefined') {
          localStorage.removeItem('active_work_firma');
        }
      } catch (e) { }
    },

    openSelectModal(pendingRoute = null) {
      this.pendingTargetRoute = pendingRoute;
      this.isModalOpen = true;
    },

    closeSelectModal() {
      this.isModalOpen = false;
      this.pendingTargetRoute = null;
    },

    async fetchFirmaById(id) {
      if (!id) return null;
      this.loadingFirma = true;
      try {
        const res = await axios.get(`/api/administrare/work/firma/${id}`);
        if (res?.data?.firma) {
          this.setFirma(res.data.firma);
          return this.selectedFirma;
        }
      } catch (err) {
        console.error(`Eroare la incarcarea firmei #${id}:`, err);
      } finally {
        this.loadingFirma = false;
      }
      return null;
    },

    loadFromStorage() {
      try {
        if (typeof localStorage !== 'undefined') {
          const stored = localStorage.getItem('active_work_firma');
          if (stored) {
            const parsed = JSON.parse(stored);
            if (parsed && parsed.id) {
              this.selectedFirma = parsed;
            }
          }
        }
      } catch (e) {
        console.warn('Eroare la citirea firmei din localStorage:', e);
      }
    }
  }
});
